<header class="header">
  <img
    class="logo"
    src="../../../assets/logos/seat-cupra-logo-black.svg"
    alt="{{ 'altLogo' | i18next }}"
  />
  <h2 class="header--title" *ngIf="group !== 'VL'">
    {{ 'documentationTitle' | i18next }} {{ 'documentationGroup' | i18next }}
    {{ groupTranslation }}
  </h2>
  <h2 class="header--title" *ngIf="group === 'VL'">
    {{ 'documentationTitle' | i18next }} - {{ 'vl' | i18next }}
  </h2>
</header>

<main class="main">
  <div class="card card-table">
    <table mat-table [dataSource]="documents" class="table">
      <!-- <thead>
        <tr>
          <th class="table-title" scope="col">
            {{ 'documentsTableTile' | i18next }}
          </th>
        </tr>
      </thead> -->
      <!-- Columna Documento -->
      <ng-container matColumnDef="documentName">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentationTableDescription' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.name || ('noData' | i18next) }}
        </td>
      </ng-container>
      <!-- Columna Descargar -->
      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'btnDownload' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            class="actions"
            mat-button
            (click)="showDocument(element.name)"
            [disabled]="!element.name"
            matTooltip="{{ 'downloadTooltip' | i18next }}"
          >
            <mat-icon
              aria-hidden="false"
              aria-label="Download"
              fontIcon="file_download"
            ></mat-icon>
          </button>
        </td>
      </ng-container>
      <!-- <ng-container *ngFor="let document of documents">
          <tr>
            <td class="table-row">
              <p class="document-title">{{ document }}</p>
              <button
                class="btn"
                type="button"
                (click)="showDocument(document)"
              >
                {{ 'btnSee' | i18next }}
              </button>
            </td>
          </tr>
        </ng-container> -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <!-- <div
    class="card card-table"
    *ngIf="orderInfo.requestType === requestTypesEnum.leasing"
  >
    <table mat-table [dataSource]="dataSource" class="table">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'creationDate' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.date ? element.date : ('noData' | i18next) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="documentType">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentType' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.documentType | i18next }}
        </td>
      </ng-container>

      <ng-container matColumnDef="document">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'documentationTableDescription' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.document ? element.document : ('noData' | i18next) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'status' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.status ? element.status : ('noData' | i18next) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>
          {{ 'requestListActions' | i18next }}
        </th>
        <td mat-cell *matCellDef="let element">
          <div [hidden]="element.spinner">
            <button
              class="actions"
              mat-button
              (click)="downloadDocument(element)"
              [disabled]="!element.document"
              matTooltip="{{ 'downloadTooltip' | i18next }}"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Download"
                fontIcon="file_download"
              ></mat-icon>
            </button>
            <button
              class="actions"
              mat-button
              (click)="uploadDocument(element)"
              [disabled]="element.status !== ('pendingUpload' | i18next)"
              matTooltip="{{ 'addDoc' | i18next }}"
            >
              <mat-icon
                aria-hidden="false"
                aria-label="Upload"
                fontIcon="file_upload"
              ></mat-icon>
            </button>
          </div>
          <div *ngIf="element.spinner">
            <div class="spinner-border spinner" role="status"></div>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div> -->
</main>
